import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { addPageData, navigateWizard } from '../../actions';
import QuestionPageLayout from '../../components/QuestionPageLayout';
import analytics from '../../lib/analytics';
import * as payloadFactory from '../../lib/pageDataPayloadFactory';

const FullTimeJobPage = ({ initialFullTimeJob, dispatchAddPageData, dispatchWizardNav }) => {
  const handleSubmit = fullTimeJob => {
    analytics.sendEvent('Click - Next', 'full-time-job');

    const payload = payloadFactory.createAddPageDataPayload('fullTimeJob', fullTimeJob);
    dispatchAddPageData(payload);
    dispatchWizardNav({ dir: 'fwd' });
  };

  const helpText =
    'As you have selected a part-time course, let us know if you currently hold a full-time job and intend to continue working during study.';
  return (
    <QuestionPageLayout
      id="full-time-employed"
      value={initialFullTimeJob}
      title="Do you currently hold a full-time job?"
      onSubmit={handleSubmit}
      helpText={helpText}
    />
  );
};

FullTimeJobPage.propTypes = {
  initialFullTimeJob: PropTypes.bool,
  dispatchAddPageData: PropTypes.func.isRequired,
  dispatchWizardNav: PropTypes.func.isRequired,
};

FullTimeJobPage.defaultProps = {
  initialFullTimeJob: null,
};

export const mapStateToProps = reduxState => ({
  initialFullTimeJob: reduxState.builder.ui.fullTimeJob,
});

export const mapDispatchToProps = {
  dispatchAddPageData: addPageData,
  dispatchWizardNav: navigateWizard,
};

export { FullTimeJobPage };

export default connect(mapStateToProps, mapDispatchToProps)(FullTimeJobPage);
